export default __webpack_public_path__ + "static/media/Output_section.39fccabf.png";